import React, { Fragment } from "react";
import PopupMenu from "../../../SimpleForm/PopupMenu";
import { FaEllipsisH } from "react-icons/fa";
import RemoveEntity from "../../RemoveLinkedProfile";

const ActionsPopup = (props) => {
  const {
    actionsPopupSchema,
    id,
    removeLinkedProfile,
    formApi,
    linkedProfilesMachineName,
    setLinkedProfiles,
    linkedProfiles,
    removedProfilesMachineName,
  } = props;

  const contentStyle = {
    boxShadow: "inset 0px 4px 0px 0px #AEB0B5, 0 2px 6px 0 rgba(0,0,0,0.5)",
    padding: "0",
    paddingTop: "4px",
    border: "none",
  };

  const arrowStyle = {
    width: "0",
    height: "0",
    borderStyle: "solid",
    borderWidth: "0 0 13px 13px",
    outline: "none",
    borderColor: "transparent transparent #AEB0B5 transparent",
    background: "transparent",
    boxShadow: "none",
  };

  const renderMenuItem = (menuItem, id) => {
    const { color, label, action, component: Component } = menuItem;

    const menuItemStyle = {
      padding: "14px 10px 14px 20px",
      color: `${color}`,
      cursor: "pointer",
    };

    if (Component) {
      return <Component menuItemStyle={menuItemStyle} id={id} />;
    } else {
      return (
        <button
          style={menuItemStyle}
          className="menu-item menu-item-button dropdown-label-View"
          onClick={action}
          type="button"
        >
          <span>{label}</span>
        </button>
      );
    }
  };

  const renderAllMenuItems = actionsPopupSchema.map((menuItem, index, arr) => (
    <Fragment key={index}>
      {renderMenuItem(menuItem, id)}
      {arr.length - 1 !== index && <hr />}
    </Fragment>
  ));

  return (
    <PopupMenu
      contentStyle={contentStyle}
      arrowStyle={arrowStyle}
      trigger={
        <button
          type="button"
          style={{ border: "none", background: "transparent" }}
        >
          <FaEllipsisH
            className="EllipsisIcon ellipsis-action"
            size={20}
            style={{ cursor: "pointer" }}
          />
        </button>
      }
      position="bottom right"
      closeOnDocumentClick
    >
      <div>
        {renderAllMenuItems}
        {!!removeLinkedProfile && (
          <>
            <hr />
            <RemoveEntity
              id={id}
              formApi={formApi}
              machineName={linkedProfilesMachineName}
              setLinkedProfiles={setLinkedProfiles}
              linkedProfiles={linkedProfiles}
              removedProfilesMachineName={removedProfilesMachineName}
            />
          </>
        )}
      </div>
    </PopupMenu>
  );
};

export default ActionsPopup;
